import React, { Fragment } from 'react';
import { Col, Row } from 'reactstrap';
import { PageAnimation } from '../../Layout/Components/Animation';
import { useAuth } from '../../Context/Auth/AuthContext';
import PageTitle from '../../Layout/Components/PageTitle';
import EditCampaignModule from '../../modules/campaign/edit/EditCampaignModule';

export default function Edit() {
  const { currentCampaign } = useAuth();

  return (
    <Fragment>
      <PageAnimation>
        <PageTitle
          heading={currentCampaign.coln}
          subheading={currentCampaign.cold}
          icon="pe-7s-display1"
        />

        <Row className='mb-4'>
          <Col md={12}>
            <EditCampaignModule />
          </Col>
        </Row>

      </PageAnimation>
    </Fragment>
  );
}
